/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const e = "upload.cancel", l = "upload.clearSelectedFiles", o = "upload.dropFilesHere", t = "upload.headerStatusUploaded", a = "upload.headerStatusUploading", s = "upload.invalidFileExtension", d = "upload.invalidFiles", i = "upload.invalidMaxFileSize", n = "upload.invalidMinFileSize", p = "upload.remove", c = "upload.retry", u = "upload.select", r = "upload.selectTitle", F = "upload.selectNoFilesTitle", f = "upload.uploadSelectedFiles", S = "upload.total", v = "upload.files", U = "upload.statusUploaded", h = "upload.statusUploadFailed", m = "upload.dropZoneHint", N = "upload.defaultDropZoneNote", g = "upload.dropZoneNote", y = {
  [e]: "Cancel",
  [l]: "Clear",
  [o]: "Drop files here to upload",
  [t]: "Done",
  [a]: "Uploading...",
  [s]: "File type not allowed.",
  [d]: "Invalid file(s). Please check file upload requirements.",
  [i]: "File size too large.",
  [n]: "File size too small.",
  [p]: "Remove",
  [c]: "Retry",
  [u]: "Select files...",
  [r]: "Press to select more files",
  [F]: "No files selected",
  [f]: "Upload",
  [S]: "Total",
  [v]: "files",
  [U]: "File(s) successfully uploaded.",
  [h]: "File(s) failed to upload.",
  [m]: "Drag and drop files here to upload.",
  [N]: "",
  [g]: "Only {0} files are allowed."
};
export {
  e as cancel,
  l as clearSelectedFiles,
  o as dropFilesHere,
  m as dropZoneHint,
  N as dropZoneNote,
  v as files,
  t as headerStatusUploaded,
  a as headerStatusUploading,
  s as invalidFileExtension,
  d as invalidFiles,
  i as invalidMaxFileSize,
  n as invalidMinFileSize,
  y as messages,
  p as remove,
  g as restrictionsDropZoneNote,
  c as retry,
  u as select,
  F as selectNoFilesTitle,
  r as selectTitle,
  h as statusUploadFailed,
  U as statusUploaded,
  S as total,
  f as uploadSelectedFiles
};
